<td class="text-center text-nowrap align-middle link">                                
    <button type="button" class="btn btn-xs icon-btn btn-warning" [routerLink]="['/operacionais/documentos/documentos-cadastro', documento.id]">
        <span class="far fa-edit"></span>
    </button>                                
</td>